/**
 * Shared WebSocket utilities used by all real-time hooks.
 */

/** Reconnect cap — 30 s before jitter. */
export const MAX_RECONNECT_DELAY_MS = 30_000;

/**
 * Exponential backoff with ±1 s jitter.
 * attempt=0 → ~1 s, attempt=1 → ~2 s, … capped at MAX_RECONNECT_DELAY_MS.
 * Jitter spreads reconnect storms when many clients lose the server at once.
 */
export function backoffDelay(attempt: number): number {
  const base = Math.min(1000 * 2 ** attempt, MAX_RECONNECT_DELAY_MS);
  return base + Math.random() * 1000;
}

/** Build a ws:// or wss:// URL for the given server-relative path. */
export function buildWebSocketUrl(path: string): string {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}${path}`;
}
